var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _ellipse, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsBannerIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46.4824,
    width: 34.8117,
    height: 47.4705,
    rx: 12,
    fill: "#232327"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122.105,
    y: 46.4829,
    width: 34.8117,
    height: 47.4705,
    rx: 12,
    fill: "#232327"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6602 63C36.6602 38.1471 56.8073 18 81.6601 18H97.6777C122.531 18 142.678 38.1472 142.678 63V107.435C142.678 115.719 135.962 122.435 127.678 122.435H51.6602C43.3759 122.435 36.6602 115.719 36.6602 107.435V63Z",
    fill: "#434652"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4844 72.591C52.4844 52.0542 69.1328 35.4058 89.6696 35.4058C110.206 35.4058 126.855 52.0542 126.855 72.591V75.7557C126.855 83.1839 120.833 89.2057 113.405 89.2057H65.9343C58.5061 89.2057 52.4844 83.1839 52.4844 75.7557V72.591Z",
    fill: "#232327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0547 55.9766V67.053",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.285 55.9766V67.053",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8828 160.914C91.3517 160.022 94.5833 150.885 95.1405 146.427L107.398 157.014C98.4835 163.7 87.3401 162.4 82.8828 160.914Z",
    fill: "#232327"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.442,
    cy: 130.269,
    rx: 39.5588,
    ry: 31.7585,
    fill: "#232327"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.611,
    cy: 130.269,
    r: 3.90017,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.439,
    cy: 130.269,
    r: 3.90017,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.271,
    cy: 130.269,
    r: 3.90017,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBannerIcon4);
export default __webpack_public_path__ + "static/media/skills-bannerIcon_4.4421856c0689dce201e62c7839edc9d8.svg";
export { ForwardRef as ReactComponent };